import { styled } from "styled-components";
import { FlexColumn } from "../Styles";
import UserCard from "../UserCard";
import { CommonInterests } from "./CommonInterests";
import { UserCardWithCommonInterestsProps } from "./UserCardWithCommonInterests";

export const UserCardWithCommonInterests = (
  props: UserCardWithCommonInterestsProps.IProps
) => {
  return (
    <Container>
      <UserCard {...props} />
      <CommonInterests />
    </Container>
  );
};

const Container = styled(FlexColumn)`
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-secondary"].value};
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;

  &:hover {
    background: ${({ theme }) =>
      theme.Color.elevation.surface["surface-primary-hover"].value};
  }
`;
